var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IntegrationActiveCalcEvent_1;
import { DateConverter, JSON, JsonConverter, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { CalculationStatus } from './baseCalculation';
import { NodeCalculationStatus } from './nodeCalculationStatus';
export var CalculationInitializationType;
(function (CalculationInitializationType) {
    CalculationInitializationType["WithDependees"] = "withDependees";
    CalculationInitializationType["WithoutDependees"] = "withoutDependees";
    CalculationInitializationType["CalcAll"] = "calcAll"; // when calc is started with postCalculationsForAll endpoint
})(CalculationInitializationType || (CalculationInitializationType = {}));
const schema = {
    $id: 'urn:wisepipe-common-computation:IntegrationActiveCalcEvent',
    type: 'object',
    properties: {
        orgID: { type: 'string', minLength: 1, maxLength: 128 },
        pipeID: { type: 'string', uid: 10 },
        externalID: { type: 'string', minLength: 1 },
        status: { type: 'string', enum: Object.values(CalculationStatus) },
        calcInitType: { type: 'string', enum: Object.values(CalculationInitializationType) },
        taskID: { type: 'string', minLength: 1 },
        rootTaskID: { type: 'string' },
        error: { type: 'object' },
        start: { type: 'string', format: 'date-time' },
        end: { type: 'string', format: 'date-time' },
        processingStartTime: { type: 'string', format: 'date-time' },
        nodeCalcStatusSummary: {
            type: 'object',
            additionalProperties: { type: 'string', enum: Object.values(NodeCalculationStatus) }
        }
    },
    required: ['orgID', 'pipeID', 'status', 'start', 'taskID']
};
let IntegrationActiveCalcEvent = IntegrationActiveCalcEvent_1 = class IntegrationActiveCalcEvent {
    constructor(orgID, pipeID, status, taskID, start, end, processStartTime, rootTaskID, externalID, calcInitType, nodeCalcStatusSummary, error) {
        this.orgID = orgID;
        this.pipeID = pipeID;
        this.status = status;
        this.taskID = taskID;
        this.rootTaskID = rootTaskID;
        this.externalID = externalID;
        this.calcInitType = calcInitType;
        this.start = start;
        this.end = end;
        this.processingStartTime = processStartTime;
        this.nodeCalcStatusSummary = nodeCalcStatusSummary;
        this.error = error;
        JSON.validate(this, IntegrationActiveCalcEvent_1);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], IntegrationActiveCalcEvent.prototype, "start", void 0);
__decorate([
    JsonConverter(new DateConverter('date-time'))
], IntegrationActiveCalcEvent.prototype, "end", void 0);
__decorate([
    JsonConverter(new DateConverter('date-time'))
], IntegrationActiveCalcEvent.prototype, "processingStartTime", void 0);
IntegrationActiveCalcEvent = IntegrationActiveCalcEvent_1 = __decorate([
    JsonSchema(schema)
], IntegrationActiveCalcEvent);
export { IntegrationActiveCalcEvent };
//# sourceMappingURL=integrationActiveCalcEvent.js.map